
import React from "react";

const DocumentationProcessSimplifiedSection = () => {
  return (
    <section className="py-5">
    <div className="container">
      {/* Section: Supplementary Documents */}
      <div className="row supplymentry-asiatic">
        <div className="col-md-12">
          
          <p>
            Submit self- attested photocopies of at-least one of the following documents under each section along with the KYCto complete the account opening process. Also mentioned in the checklist are instances where the original supporting documents are required.
          </p>
        </div>

        <div className="clearfix"></div>

        <div className="col-md-6">
          <p>
            <strong>Photographs:</strong>- 1 Passport size photograph to be
            affixed for a trading account. An additional photograph if a demat
            account is also being opened.
          </p>
          <br />
          <p>
            <strong>Note:</strong>- Income proof is binding ONLY for clients trading in derivatives - Bank statements if submitted can be used as supporting documents for Address and Income proof
          </p>
        
          <br />

          <h5 style={{ textAlign: "left", textTransform: "uppercase", color: "#000" }}>
            Account opening charges?
          </h5>
          <p>
            <strong>Our account opening charges comprise of:</strong>
            <br />
            • Trading @ Rs.350/- includes equities and currencies
          </p>
          <br />

          <h5 style={{ textAlign: "left", textTransform: "uppercase", color: "#000" }}>
            Account opening process
          </h5>
          <p>
           Follow the simple steps illustrated below to complete your account opening process. Before sending the completed documents to us, ensure signatures of witnesses, your self- attested supporting documents and a cheque comprising of Account Opening Charges favoring Asiatic Stock & Securities Ltd.
          </p>
        </div>

        <div className="col-md-6">
          <img
            src="assets/images/about-images.png"
            alt="Asiatic"
            className="img-responsive"
          />
        </div>
      </div>

      <div className="clearfix"></div>

      {/* Section: KRA */}
      <div className="row daigram-asiatic">
        <div className="col-md-12">
          <h5 className="supplymentry">What is KRA?</h5>
          <p>
           KRA stands for know your client registration agency With a view to bring uniformity in the KYC requirements for the securities markets; SEBI has initiated usage of uniform KYC by all SEBI registered intermediaries. KRA centralizes all KYC records in the securities market. On opening an account with a SEBI registered intermediary, you are required to fill out your KYC information along with supporting documents. The Intermediary on their part will upload all the material on the system of the KYC Registration Agency (KRA). All SEBI Registered Intermediaries while dealing can access this KYC information with the same client for detailed information on the SEBI notification,
          </p>
        </div>

        <div className="clearfix"></div>

        <div className="col-md-6">
          <h5 style={{ textAlign: "left", textTransform: "uppercase"}}>
            How does KRA simplify account-opening process?
          </h5>
          <p >
            Once the KYC process is completed with a SEBI registered intermediary/ broker, a trader does not have to undergo the entire process again with another intermediary In simpler words, if the KRA- KYC is already verified, supporting documents such as PAN card & address proof are not essential; as long as the address is the same as the one registered with the original KRA- KYC. In addition, the In- person verification (IPV) is not necessary
          </p>
         

          <h5 style={{ textAlign: "left", textTransform: "uppercase"}}>          
How does KRA simplify account-opening process?
          </h5>
          <p>
            Yes, commodities & currencies exchanges in India recognize KRA
          </p>
        

          <h5 style={{ textAlign: "left", textTransform: "uppercase"}}>
            SEBI authorized KRA agencies
          </h5>
          <p>
         NSDL Database Management Limited (NDML) and CDSL Ventures Limited (CVL)
          </p>
        
        </div>

        <div className="col-md-6">
          <img
            src="assets/images/daigram.png"
            alt="Asiatic Diagram"
            className="img-responsive"
          />
        </div>

        <div className="clearfix"></div>

        <div className="col-md-12">
          <h5 style={{ textAlign: "left", textTransform: "uppercase"}}>
            What is IPV and why is it necessary?
          </h5>
          <p>
            Exchange norms require intermediaries to complete In-person verification (IPV) of clients signing- up along with their original documents such as pan-card, address, income proofs and so on. For clients based in Delhi, our representatives stationed here will complete the IPV.
          </p>
        

          <h5 style={{ textAlign: "left", textTransform: "uppercase"}}>
           How do we implement IPV for out- station clients?
          </h5>
          <p>
            The IPV will be established via web-cam. In addition, O/S clients can submit either one of the following docs to complete address proof verification:
            <br />a) Self- attested originals of utility bills
            <br />b) Self- attested photocopies of any one document mentioned under Address proof
          </p>
        </div>
      </div>

  

    </div>
    </section>
  );
};

export default DocumentationProcessSimplifiedSection;
